var map = {
	"./nexmind_1.avif": 8483,
	"./nexmind_10.png": 1195,
	"./nexmind_2.jpg": 7116,
	"./nexmind_3.avif": 873,
	"./nexmind_4.avif": 3032,
	"./nexmind_5.png": 8199,
	"./nexmind_6.png": 9724,
	"./nexmind_7.png": 2613,
	"./nexmind_8.png": 610,
	"./nexmind_9.png": 9611
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4332;